import { FC } from "react";
import { Grid } from "antd";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import useModuleSelect from "../../useModuleSelect";
import ModulesMenuMob from "./layouts/Menu.mob";
import ModulesMenuWeb from "./layouts/Menu.web";

const ModulesMenuComponent = withConditionalComponent(ModulesMenuWeb, ModulesMenuMob);

const ModulesMenu: FC<{ onSelect?: () => void }> = ({ onSelect }) => {
  const { items, activeKey, handleSelection } = useModuleSelect();
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  const handleClick = (key: string) => {
    handleSelection(key);
    onSelect?.();
  };

  return (
    <ModulesMenuComponent
      trigger={isLargeScreen}
      componentAProps={{ items, selectedKeys: [activeKey], onClick: (info: { key: string }) => handleClick(info.key) }}
      componentBProps={{ items, activeKey, onClick: handleClick }}
    />
  );
};

export default ModulesMenu;
